import { render } from "./folder-list.vue?vue&type=template&id=73e5a062"
import script from "./folder-list.vue?vue&type=script&lang=ts"
export * from "./folder-list.vue?vue&type=script&lang=ts"
script.render = render

export default script